import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback } from 'react';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { FormattedMessage } from 'react-intl';
import { useFullscreen } from '@niche-js/core/hooks';
import { PropTypes as PropTypes$1 } from '@niche-js/core';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import isEmpty from 'lodash/isEmpty';
import { isEmpty as isEmpty$1 } from 'lodash';

var styles$1 = {"container":"niche-js-core-editor-preview-container","inner":"niche-js-core-editor-preview-inner","editor":"niche-js-core-editor-preview-editor","fullscreen":"niche-js-core-editor-preview-fullscreen","desktop":"niche-js-core-editor-preview-desktop","tablet":"niche-js-core-editor-preview-tablet","phone":"niche-js-core-editor-preview-phone"};

var propTypes$7 = {
  platforms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })),
  platformId: PropTypes.string,
  onPlatformChange: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node
};
var defaultProps$7 = {
  platforms: [{
    id: 'urbania_ca',
    name: 'urbania.ca'
  }, {
    id: 'urbania_fr',
    name: 'urbania.fr'
  }],
  platformId: null,
  onPlatformChange: null,
  className: null,
  children: null
};
function Preview(_ref) {
  var platforms = _ref.platforms,
    platformId = _ref.platformId,
    onPlatformChange = _ref.onPlatformChange,
    className = _ref.className,
    children = _ref.children;
  var body = useMemo(function () {
    window.document.querySelector('body');
  }, []);
  var _useFullscreen = useFullscreen(body),
    toggleFullscreen = _useFullscreen.toggle,
    _useFullscreen$active = _useFullscreen.active,
    fullscreen = _useFullscreen$active === void 0 ? false : _useFullscreen$active;
  var platform = (platforms || []).find(function (_ref2) {
    var _ref2$id = _ref2.id,
      id = _ref2$id === void 0 ? null : _ref2$id;
    return id === platformId;
  }) || null;
  var _useState = useState('desktop'),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var onClickSize = useCallback(function (newSize) {
    setSize(newSize);
  }, [setSize]);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var toggleOpen = useCallback(function () {
    setOpen(!open);
  }, [open, setOpen]);
  var onClickPlatform = useCallback(function (newPlatform) {
    if (onPlatformChange !== null) {
      onPlatformChange(newPlatform);
    }
    setOpen(false);
  }, [onPlatformChange]);
  var _ref3 = platform || {},
    platformName = _ref3.label;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$1.container, _defineProperty(_defineProperty(_defineProperty({}, styles$1["".concat(size)], size !== null), styles$1.fullscreen, fullscreen), className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-outline-secondary btn-sm dropdown-toggle me-2",
    type: "button",
    onClick: toggleOpen
  }, platformName || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "OPxJx/",
    defaultMessage: [{
      "type": 0,
      "value": "Layout"
    }]
  })), /*#__PURE__*/React.createElement("ul", {
    className: classNames(['dropdown-menu', {
      show: open
    }])
  }, (platforms || []).map(function (it) {
    return /*#__PURE__*/React.createElement("li", {
      key: "platform-".concat(it.id)
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: classNames(['btn btn-sm btn-outline-secondary dropdown-item', {
        active: platform !== null && it.id === platform.id
      }]),
      onClick: function onClick() {
        return onClickPlatform(platform !== null && it.id === platform.id ? null : it);
      }
    }, it.label));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "btn-group",
    role: "group"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(['btn btn-sm btn-outline-secondary', {
      active: size === 'desktop'
    }]),
    onClick: function onClick() {
      return onClickSize('desktop');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi-window-desktop"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(['btn btn-sm btn-outline-secondary', {
      active: size === 'tablet'
    }]),
    onClick: function onClick() {
      return onClickSize('tablet');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi-tablet"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(['btn btn-sm btn-outline-secondary', {
      active: size === 'phone'
    }]),
    onClick: function onClick() {
      return onClickSize('phone');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi-phone"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ms-auto"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(['btn btn-sm btn-outline-secondary btn-outline']),
    onClick: function onClick() {
      return toggleFullscreen();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi-arrows-fullscreen"
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.inner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.editor
  }, children)));
}
Preview.propTypes = propTypes$7;
Preview.defaultProps = defaultProps$7;

var styles = {"container":"niche-js-core-editor-container","main":"niche-js-core-editor-main","outline":"niche-js-core-editor-outline","settings":"niche-js-core-editor-settings"};

var propTypes$6 = {
  platformId: PropTypes.string,
  platforms: PropTypes.arrayOf(PropTypes.shape({})),
  onPlatformChange: PropTypes.func,
  outline: PropTypes.node,
  settings: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string
};
var defaultProps$6 = {
  platformId: null,
  platforms: null,
  onPlatformChange: null,
  outline: null,
  settings: null,
  className: null,
  children: null
};
function Editor(_ref) {
  var platformId = _ref.platformId,
    platforms = _ref.platforms,
    onPlatformChange = _ref.onPlatformChange,
    outline = _ref.outline,
    settings = _ref.settings,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', 'w-100', styles.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("aside", {
    className: classNames(['bg-light', styles.outline])
  }, outline), /*#__PURE__*/React.createElement("main", {
    className: classNames(['flex-grow-1', styles.main])
  }, /*#__PURE__*/React.createElement(Preview, {
    platforms: platforms,
    platformId: platformId,
    onPlatformChange: onPlatformChange
  }, children)), /*#__PURE__*/React.createElement("aside", {
    className: classNames(['bg-light', styles.settings])
  }, settings));
}
Editor.propTypes = propTypes$6;
Editor.defaultProps = defaultProps$6;

var propTypes$5 = {
  component: PropTypes$1.component.isRequired,
  tag: PropTypes.string,
  inline: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};
var defaultProps$5 = {
  tag: 'div',
  inline: false,
  className: null,
  children: null
};
function Component(_ref) {
  var component = _ref.component,
    tag = _ref.tag;
    _ref.inline;
    var className = _ref.className,
    children = _ref.children;
  var _ref2 = component || {};
    _ref2.id;
    _ref2.uuid;
    _ref2.role;
    _ref2.type;
    _ref2.platform;
    var _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? null : _ref2$theme,
    _ref2$presentation = _ref2.presentation,
    presentation = _ref2$presentation === void 0 ? null : _ref2$presentation;
  var Tag = tag || 'div';
  return /*#__PURE__*/React.createElement(Tag, Object.assign({
    className: classNames([_defineProperty({}, className, className !== null)])
  }, null, {
    "data-presentation": presentation,
    "data-theme": theme
  }), children);
}
Component.propTypes = propTypes$5;
Component.defaultProps = defaultProps$5;

var _excluded = ["name", "tag", "attributes", "html", "children", "inline", "placeholder", "className"];
var propTypes$4 = {
  name: PropTypes.string.isRequired,
  tag: PropTypes.string,
  attributes: PropTypes.string,
  html: PropTypes.string,
  children: PropTypes.node,
  inline: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string
};
var defaultProps$4 = {
  tag: 'div',
  attributes: null,
  html: null,
  children: null,
  inline: false,
  placeholder: null,
  className: null
};
function Editable(_ref) {
  _ref.name;
    var tag = _ref.tag;
    _ref.attributes;
    var html = _ref.html,
    children = _ref.children;
    _ref.inline;
    _ref.placeholder;
    var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag || 'div';
  children === null && (isEmpty(html) || html === '&nbsp;');
  return /*#__PURE__*/React.createElement(Tag, Object.assign({
    className: className,
    dangerouslySetInnerHTML: html !== null ? {
      __html: html
    } : null
  }, props), children);
}
Editable.propTypes = propTypes$4;
Editable.defaultProps = defaultProps$4;

var propTypes$3 = {
  name: PropTypes.string.isRequired,
  tag: PropTypes.string,
  html: PropTypes.string,
  children: PropTypes.node,
  placeholder: PropTypes.string,
  className: PropTypes.string
};
var defaultProps$3 = {
  tag: 'div',
  html: null,
  children: null,
  placeholder: null,
  className: null
};
function EditableField(_ref) {
  _ref.name;
    var tag = _ref.tag,
    html = _ref.html,
    children = _ref.children;
    _ref.placeholder;
    var className = _ref.className;
  var Tag = tag || 'div';
  children === null && (isEmpty$1(html) || html === '&nbsp;');
  return /*#__PURE__*/React.createElement(Tag, {
    className: className,
    dangerouslySetInnerHTML: html !== null ? {
      __html: html
    } : null
  }, children);
}
EditableField.propTypes = propTypes$3;
EditableField.defaultProps = defaultProps$3;

// import placeholderImage from '../../images/placeholder.png';

var propTypes$2 = {
  name: PropTypes.string.isRequired,
  src: PropTypes.string,
  alt: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string
};
var defaultProps$2 = {
  src: null,
  alt: null,
  placeholder: null,
  className: null
};
function EditableImage(_ref) {
  _ref.name;
    var src = _ref.src,
    alt = _ref.alt;
    _ref.placeholder;
    var className = _ref.className;
  return /*#__PURE__*/React.createElement("img", {
    className: classNames([_defineProperty({}, className, className !== null)]),
    src: src,
    alt: alt
  });
}
EditableImage.propTypes = propTypes$2;
EditableImage.defaultProps = defaultProps$2;

var propTypes$1 = {
  name: PropTypes.string.isRequired,
  tag: PropTypes.string,
  attributes: PropTypes.string,
  html: PropTypes.string,
  children: PropTypes.node,
  inline: PropTypes.bool,
  picker: PropTypes.string,
  placeholder: PropTypes.string,
  empty: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps$1 = {
  tag: 'div',
  attributes: null,
  html: null,
  children: null,
  inline: false,
  picker: null,
  placeholder: null,
  empty: false,
  className: null
};
function EditablePicker(_ref) {
  _ref.name;
    var tag = _ref.tag;
    _ref.attributes;
    var html = _ref.html,
    children = _ref.children;
    _ref.inline;
    _ref.picker;
    _ref.placeholder;
    var empty = _ref.empty,
    className = _ref.className;
  var Tag = tag || 'div';
  empty || children === null && (isEmpty(html) || html === '&nbsp;');
  return /*#__PURE__*/React.createElement(Tag, {
    className: className,
    dangerouslySetInnerHTML: html !== null ? {
      __html: html
    } : null
  }, children);
}
EditablePicker.propTypes = propTypes$1;
EditablePicker.defaultProps = defaultProps$1;

/* eslint-disable react/jsx-props-no-spreading */
// import classNames from 'classnames';
var propTypes = {
  tag: PropTypes.string,
  containerRef: PropTypes.oneOfType([PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  PropTypes.shape({
    current: PropTypes.any
  })]),
  withoutUI: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};
var defaultProps = {
  tag: 'div',
  containerRef: null,
  withoutUI: false,
  className: null,
  children: null
};
function Widget(_ref) {
  var tag = _ref.tag,
    containerRef = _ref.containerRef;
    _ref.withoutUI;
    var className = _ref.className,
    children = _ref.children;
  var Tag = tag || 'div';
  return /*#__PURE__*/React.createElement(Tag, Object.assign({
    className: className,
    ref: containerRef
  }, null), children);
}
Widget.propTypes = propTypes;
Widget.defaultProps = defaultProps;
var Widget$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Widget, Object.assign({}, props, {
    containerRef: ref
  }));
});

export { Component, Editable, EditableField, EditableImage, EditablePicker, Editor, Preview, Widget$1 as Widget };
